/**
 * Scroll lock for the Moony modal.
 *
 * The document is the scroller (see base.css), so locking means disabling
 * `overflow` on <html> while remembering the exact offset. Snap is disabled at
 * the same time, otherwise restoring the offset gets pulled to a snap boundary
 * and the page visibly jumps when the modal closes.
 *
 * Nested locks are reference-counted so two overlays never fight each other.
 */

import { useEffect } from 'react';

let depth = 0;
let savedScrollY = 0;

export function useScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;

    const html = document.documentElement;
    if (depth === 0) {
      savedScrollY = window.scrollY;
      html.classList.add('is-modal-open');
    }
    depth += 1;

    const onKey = (event) => {
      // Block page scrolling behind the modal while still allowing the modal's
      // own scroller (which sets overscroll-behavior: contain) to work.
      if (event.key === ' ' && event.target === document.body) event.preventDefault();
    };
    window.addEventListener('keydown', onKey, { passive: false });

    return () => {
      window.removeEventListener('keydown', onKey);
      depth = Math.max(0, depth - 1);
      if (depth === 0) {
        html.classList.remove('is-modal-open');
        window.scrollTo({ top: savedScrollY, behavior: 'auto' });
      }
    };
  }, [active]);
}
